/**
 * Sichere Storage-Hilfe: Alle Zugriffe in try-catch.
 * Verhindert Console-Spam und Abstürze, wenn der Browser
 * "Tracking Prevention" aktiv hat und localStorage blockiert.
 */

function safeGetItem(key: string): string | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSetItem(key: string, value: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(key, value);
  } catch {
    /* Tracking Prevention / Storage blockiert */
  }
}

function safeRemoveItem(key: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(key);
  } catch {
    /* Tracking Prevention / Storage blockiert */
  }
}

function safeSessionGetItem(key: string): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSessionSetItem(key: string, value: string): void {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(key, value);
  } catch {
    /* Tracking Prevention / Storage blockiert */
  }
}

export const storage = {
  getItem: safeGetItem,
  setItem: safeSetItem,
  removeItem: safeRemoveItem,
  session: {
    getItem: safeSessionGetItem,
    setItem: safeSessionSetItem,
  },
};
